import React from 'react'
import classNames from 'classnames'

import Link from '@components/link'
import Markdown from '@components/markdown'
import styles from '@components/blocks/subheader_block.module.scss'
import ctaStyles from '@components/blocks/cta_block.module.scss'
import ImageAsset from '@components/image_asset'

const SubheaderBlock = React.forwardRef(
  ({ fields: { backgroundColor, cta, layout, size, spacing, subtitle, title, image } }, _) => {
    const backgroundColorClass = (backgroundColor => {
      switch (backgroundColor) {
        case 'Tan':
          return styles['subheader_block--tan']
        case 'White':
          return styles['subheader_block--white']
        default:
          return styles['subheader_block--light_blue']
      }
    })(backgroundColor)

    const layoutClass = (layout => {
      switch (layout) {
        case 'Side by Side':
          return styles['subheader_block--side_by_side']
        default:
          return null
      }
    })(layout)

    const sizeClass = (size => {
      switch (size) {
        case 'Large':
          return styles['subheader_block--large-size']
        case 'ExtraLarge':
          return styles['subheader_block--xlarge-size']
        default:
          return null
      }
    })(size)

    const spacingClass = (spacing => {
      switch (spacing) {
        case 'Extra Top and Bottom':
          return styles['subheader_block--extra-top-and-bottom-spacing']
        case 'Extra Top':
          return styles['subheader_block--extra-top-spacing']
        case 'Extra Bottom':
          return styles['subheader_block--extra-bottom-spacing']
        default:
          return null
      }
    })(spacing)

    const getCta = () => {
      if (cta === undefined) {
        return null
      }

      const ctaText = cta.fields.ctaText
      const ctaDataAttrs = {
        'data-link-type': 'cta',
        'data-link-name': ctaText,
      }

      return (
        <div className={styles.subheader_block__cta}>
          <Link path={cta.fields.ctaPath} className={ctaStyles.ctaBlock__cta} {...ctaDataAttrs}>
            {ctaText}
          </Link>
        </div>
      )
    }

    const getImage = () => {
      if (image === undefined) {
        return null
      }

      return <ImageAsset asset={image} className={styles.subheader_block__image} />
    }

    return (
      <div
        className={classNames(
          styles.subheader_block,
          backgroundColorClass,
          layoutClass,
          sizeClass,
          spacingClass
        )}
      >
        <div className={styles.subheader_block__content}>
          {title && <h2 className={styles.subheader_block__title}>{title}</h2>}
          {subtitle && <Markdown className={styles.subheader_block__subtitle}>{subtitle}</Markdown>}
          {getCta()}
          {getImage()}
        </div>
      </div>
    )
  }
)

export default SubheaderBlock
